import axiosInstance from './axiosInstance'
import { ApiResponse, User } from '../types'

export const userApi = {
  getMe: () => axiosInstance.get<ApiResponse<User>>('/users/me'),

  updateMe: (data: {
    displayName?: string
    bio?: string
    experienceYears?: number
    linkedinUrl?: string
    skills?: string[]
  }) => axiosInstance.put<ApiResponse<User>>('/users/me', data),

  getPresignedUpload: (type: 'profile-pic' | 'resume', contentType: string) =>
    axiosInstance.get<ApiResponse<{ uploadUrl: string; s3Key: string }>>(
      `/users/me/presigned-upload?type=${type}&contentType=${encodeURIComponent(contentType)}`
    ),

  getById: (id: number) => axiosInstance.get<ApiResponse<User>>(`/users/${id}`),
}
